import React from 'react'
import Packages from '../../pages/PackagesPage/Packages';
import FAQ from '../../pages/PackagesPage/FAQ';


const PackagesPage = () => {
    return (
        <div>
            <Packages />
            <br/><br/>
            <FAQ />
           
            
        </div>
    )
}

export default PackagesPage;
